import { createContext, useContext, useState } from 'react';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [reportCount, setReportCount] = useState(0);
  const [contactCount, setContactCount] = useState(0);
  const [loading, setLoading] = useState(false);

  return (
    <SidebarContext.Provider value={{
      reportCount,
      setReportCount,
      contactCount,
      setContactCount,
      loading,
      setLoading
    }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
